/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ConnectionIdMeterIdLocalDateZonedDateTimeNullableMeasurementSourceValueTuple } from '../model/connectionIdMeterIdLocalDateZonedDateTimeNullableMeasurementSourceValueTuple';
// @ts-ignore
import { MeasurementSource } from '../model/measurementSource';
// @ts-ignore
import { MeasurementSourceDetailR } from '../model/measurementSourceDetailR';
// @ts-ignore
import { Tariff } from '../model/tariff';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class MeasurementSourceDetailService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param connectionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiConsumptionsMeasurementSourceDetailGetAllMeasureMentsourceDetailByConnectionIdGet(connectionId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<MeasurementSourceDetailR>>;
    public apiConsumptionsMeasurementSourceDetailGetAllMeasureMentsourceDetailByConnectionIdGet(connectionId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<MeasurementSourceDetailR>>>;
    public apiConsumptionsMeasurementSourceDetailGetAllMeasureMentsourceDetailByConnectionIdGet(connectionId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<MeasurementSourceDetailR>>>;
    public apiConsumptionsMeasurementSourceDetailGetAllMeasureMentsourceDetailByConnectionIdGet(connectionId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (connectionId !== undefined && connectionId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>connectionId, 'connectionId');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.get<Array<MeasurementSourceDetailR>>(`${this.configuration.basePath}/api/consumptions/MeasurementSourceDetail/GetAllMeasureMentsourceDetailByConnectionId`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param modifiedTimestamp 
     * @param withoutTariff 
     * @param connectionId 
     * @param meterId 
     * @param date 
     * @param timestamp 
     * @param tariff 
     * @param measurementSource 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiConsumptionsMeasurementSourceDetailGetAllMeasureMentsourceDetailByMeasurementIdHistoricallyGet(modifiedTimestamp?: string, withoutTariff?: ConnectionIdMeterIdLocalDateZonedDateTimeNullableMeasurementSourceValueTuple, connectionId?: string, meterId?: string, date?: string, timestamp?: string, tariff?: Tariff, measurementSource?: MeasurementSource, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<MeasurementSourceDetailR>>;
    public apiConsumptionsMeasurementSourceDetailGetAllMeasureMentsourceDetailByMeasurementIdHistoricallyGet(modifiedTimestamp?: string, withoutTariff?: ConnectionIdMeterIdLocalDateZonedDateTimeNullableMeasurementSourceValueTuple, connectionId?: string, meterId?: string, date?: string, timestamp?: string, tariff?: Tariff, measurementSource?: MeasurementSource, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<MeasurementSourceDetailR>>>;
    public apiConsumptionsMeasurementSourceDetailGetAllMeasureMentsourceDetailByMeasurementIdHistoricallyGet(modifiedTimestamp?: string, withoutTariff?: ConnectionIdMeterIdLocalDateZonedDateTimeNullableMeasurementSourceValueTuple, connectionId?: string, meterId?: string, date?: string, timestamp?: string, tariff?: Tariff, measurementSource?: MeasurementSource, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<MeasurementSourceDetailR>>>;
    public apiConsumptionsMeasurementSourceDetailGetAllMeasureMentsourceDetailByMeasurementIdHistoricallyGet(modifiedTimestamp?: string, withoutTariff?: ConnectionIdMeterIdLocalDateZonedDateTimeNullableMeasurementSourceValueTuple, connectionId?: string, meterId?: string, date?: string, timestamp?: string, tariff?: Tariff, measurementSource?: MeasurementSource, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (modifiedTimestamp !== undefined && modifiedTimestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>modifiedTimestamp, 'ModifiedTimestamp');
        }
        if (withoutTariff !== undefined && withoutTariff !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>withoutTariff, 'WithoutTariff');
        }
        if (connectionId !== undefined && connectionId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>connectionId, 'ConnectionId');
        }
        if (meterId !== undefined && meterId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>meterId, 'MeterId');
        }
        if (date !== undefined && date !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>date, 'Date');
        }
        if (timestamp !== undefined && timestamp !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timestamp, 'Timestamp');
        }
        if (tariff !== undefined && tariff !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tariff, 'Tariff');
        }
        if (measurementSource !== undefined && measurementSource !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>measurementSource, 'MeasurementSource');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (Bearer) required
        localVarCredential = this.configuration.lookupCredential('Bearer');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.get<Array<MeasurementSourceDetailR>>(`${this.configuration.basePath}/api/consumptions/MeasurementSourceDetail/GetAllMeasureMentsourceDetailByMeasurementIdHistorically`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
